import React, { Component } from "react"

/* Constants */
import { env } from '../constants'
import { LoadingOutlined } from "@ant-design/icons"


/* Widget Busy */
class Busy extends Component {

    constructor() {
        super()
        this.state = {
            loading: false
        }
    }

    loadingBegin = () => {
        this.setState({ loading: true })
        setTimeout(() => {
            this.setState({ loading: false })
        }, 3000);
    }

    render = () => {

        const { isBusy, onConnect } = this.props
        const { loading } = this.state

        if (isBusy) {
            return (
                <div className="busy">
                    <div className="busy-title">Стол занят</div>
                </div>
            )
        }

        return (
            <div className="busy">

                <div className="busy-title">Займите место</div>

                <div onClick={() => {
                    onConnect()
                    this.loadingBegin()
                }
                }
                    className="busy-connect" style={{cursor: loading ? "default" : "pointer"}}>

                    <div className="busy-connect-image">
                        {loading ? <LoadingOutlined style={{ fontSize: 35, color: "white" }} /> : <img src={`${env.mediapoint}/images/user-connect.png`} alt="User" />}
                    </div>

                    <div className="busy-play">{loading ? "    " : "Играть"}</div>

                </div>
            </div >
        )
    }

}

export default Busy